import React from 'react';
import { CheckCircle2, Shield, TrendingUp, ArrowRight, Clock, Star, CreditCard, DollarSign, Zap } from 'lucide-react';

const LimitedTimeOfferPage = () => {
  const paymentLink = "https://www.fanbasis.com/agency-checkout/THEACADEMYCEO/690w7";

  return (
    <div className="dark-page">
      {/* Hero Section */}
      <section className="tradelines-hero">
        <div className="tradelines-hero-content">
          <div className="tradelines-badge" style={{ background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)' }}>
            LIMITED TIME OFFER
          </div>
          <h1 className="display-huge tradelines-title" style={{ marginTop: '20px' }}>
            <span className="text-gradient">$74,000</span> Tradeline
          </h1>
          <h2 style={{ color: 'var(--accent-gold)', fontSize: '24px', fontWeight: '600', margin: '15px 0 25px' }}>
            + FREE Credit Repair & Student Loan Removal Included
          </h2>
          <p className="body-large tradelines-subtitle" style={{ maxWidth: '700px', margin: '0 auto 35px' }}>
            This is not just a tradeline — this is a full credit transformation package.
            For a limited time, secure this $74,000 Tradeline and receive FULL Credit Repair AND Student Loan Removal at NO additional cost.
          </p>
          
          <div className="tradelines-features-row">
            <div className="tradeline-feature-item">
              <CreditCard size={24} />
              <span>$74K High-Limit</span>
            </div>
            <div className="tradeline-feature-item">
              <Shield size={24} />
              <span>Credit Repair Included</span>
            </div>
            <div className="tradeline-feature-item">
              <Zap size={24} />
              <span>Student Loan Removal</span>
            </div>
            <div className="tradeline-feature-item">
              <Clock size={24} />
              <span>Limited Availability</span>
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="tradelines-grid-section">
        <div className="section-header">
          <h2 className="display-medium section-title">What You're Getting</h2>
          <p className="body-medium section-description">
            Three powerful services combined into one package
          </p>
        </div>
        
        <div className="tradelines-grid" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* $74,000 Tradeline Card */}
          <div className="tradeline-card">
            <div className="tradeline-card-header">
              <h3 className="tradeline-card-title">$74,000 Tradeline</h3>
            </div>
            <p className="tradeline-card-description">
              A high-limit account added directly to your credit profile, designed to strengthen your overall credit standing and improve how lenders view you.
            </p>
            <ul className="tradeline-card-features">
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>High-limit account added to your profile</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Strengthens your overall credit profile</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Improves utilization & total available credit</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Builds stronger lender perception</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Reports to all 3 major bureaus</span>
              </li>
            </ul>
          </div>

          {/* FREE Credit Repair Card */}
          <div className="tradeline-card">
            <div className="tradeline-card-header">
              <h3 className="tradeline-card-title">FREE Credit Repair</h3>
              <span style={{ background: 'var(--accent-gold)', color: '#1a0a2e', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '700' }}>INCLUDED</span>
            </div>
            <p className="tradeline-card-description">
              Full credit repair service included at no additional cost. We handle the disputes, analysis, and optimization to clean up your credit profile.
            </p>
            <ul className="tradeline-card-features">
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Removal of inaccurate & outdated items</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Strategic disputes done the right way</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Credit report analysis & optimization</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Ongoing support throughout the process</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>All 3 bureaus addressed</span>
              </li>
            </ul>
          </div>

          {/* FREE Student Loan Removal Card */}
          <div className="tradeline-card">
            <div className="tradeline-card-header">
              <h3 className="tradeline-card-title">FREE Student Loan Removal</h3>
              <span style={{ background: 'var(--accent-gold)', color: '#1a0a2e', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '700' }}>INCLUDED</span>
            </div>
            <p className="tradeline-card-description">
              Student loan debt dragging down your score? We target and remove student loan accounts from your credit reports using proven legal strategies.
            </p>
            <ul className="tradeline-card-features">
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Full 3-bureau student loan analysis</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Strategic dispute campaign</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Balance & ownership challenges</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Servicer compliance audit</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Improve debt-to-income ratio</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why This Matters */}
      <section className="wealth-for-section" style={{ background: 'var(--bg-secondary)' }}>
        <div className="section-header">
          <h2 className="display-medium section-title">Why This Matters</h2>
          <p className="body-medium section-description" style={{ maxWidth: '600px', margin: '0 auto' }}>
            Most people try to fix credit in pieces. Real results come from doing both at the same time.
          </p>
        </div>
        
        <div className="wealth-for-grid" style={{ maxWidth: '600px', margin: '30px auto 0' }}>
          <div className="wealth-for-item">
            <TrendingUp size={20} />
            <span>Build strength with tradelines</span>
          </div>
          <div className="wealth-for-item">
            <Shield size={20} />
            <span>Remove negatives with credit repair</span>
          </div>
        </div>
        
        <p style={{ textAlign: 'center', marginTop: '30px', fontSize: '18px', color: 'white', fontWeight: '500' }}>
          That's how you create a profile lenders actually approve.
        </p>
      </section>

      {/* What This Helps You Do */}
      <section className="tradelines-grid-section">
        <div className="section-header">
          <h2 className="display-medium section-title">What This Can Help You Do</h2>
        </div>
        
        <div className="wealth-for-grid" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Lower your utilization</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Increase your overall limits</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Strengthen your credit profile</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Improve approval odds</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Position yourself for higher funding</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Get lender-ready faster</span>
          </div>
        </div>
      </section>

      {/* Important Notice */}
      <section className="guarantee-banner" style={{ background: 'rgba(255, 107, 107, 0.1)', borderTop: '1px solid rgba(255, 107, 107, 0.3)', borderBottom: '1px solid rgba(255, 107, 107, 0.3)' }}>
        <div className="guarantee-content">
          <Clock size={24} style={{ color: '#ff6b6b' }} />
          <p style={{ color: 'white' }}>
            <strong>Important:</strong> This offer is not always available. FREE credit repair is only included with this specific package. Limited spots available.
          </p>
        </div>
      </section>

      {/* Final CTA */}
      <section className="tradelines-cta-section">
        <div className="tradelines-cta-content">
          <h2 className="display-medium">Ready to Transform Your Credit?</h2>
          <p className="body-large" style={{ marginBottom: '30px' }}>
            $74,000 Tradeline + FREE Credit Repair + FREE Student Loan Removal — don't miss this limited opportunity.
          </p>
          <a 
            href={paymentLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ fontSize: '18px', padding: '18px 40px' }}
          >
            Learn More <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default LimitedTimeOfferPage;
